{
  "brandTitle": "VBB PLAY — Canlı Dəstək",
  "brandShort": "VBB PLAY Dəstək",
  "liveLabel": "VBB PLAY Canlı Dəstək",
  "online": "Onlayn",
  "offline": "Oflayn",
  "close": "Bağla",
  "moreOptions": "Əlavə seçimlər",
  "closeChat": "Çatı bağla",
  "closeMenu": "Menyunu bağla",
  "operator": "VBB PLAY Operator",
  "removeFile": "Faylı sil",
  "attachFile": "Fayl əlavə et",
  "loadFailed": "Yükləmə alınmadı.",
  "fileTooLarge": "Fayl 50 MB-dan böyükdür.",
  "sendFailed": "Mesaj göndərilmədi ({{status}})",
  "networkError": "Şəbəkə xətası. Yenidən cəhd edin.",
  "nameRequired": "Adınızı daxil edin.",
  "emailInvalid": "Düzgün e-poçt ünvanı yazın.",
  "topicRequired": "Problem mövzusunu seçin.",
  "messageRequired": "Probleminizi qısa yazın.",
  "consentRequired": "Məxfilik razılığı tələb olunur.",
  "requestFailed": "Müraciət göndərilmədi.",
  "messagePlaceholder": "Qısa izah yazın…",
  "sending": "Göndərilir…",
  "startLive": "Canlı Dəstəyə başla",
  "ratingFailed": "Qiymətləndirmə göndərilmədi.",
  "ratingPlaceholder": "Qısa rəy (istəyə bağlı)",
  "contactSaveFailed": "Əlaqə məlumatı saxlanılmadı.",
  "save": "Yadda saxla",
  "loginRequired": "Canlı dəstəyə yazmaq üçün daxil olun.",
  "intakeHint": "Sizə daha sürətli kömək edə bilməyimiz üçün məlumatlarınızı daxil edin.",
  "back": "Geri",
  "yourName": "Adınız",
  "yourEmail": "E-poçt ünvanınız (Gmail və ya digər)",
  "emailPlaceholder": "email@nümunə.com",
  "topicLabel": "Problemin mövzusu",
  "topicSelect": "Seçin…",
  "messageLabel": "Probleminiz və ya mesajınız",
  "consentLong": "Şəxsi məlumatların işlənməsinə razılıq. Məxfilik Siyasəti ilə tanış oldum.",
  "soundOff": "🔊 Səsi söndürmək",
  "soundOn": "🔇 Səsi yandırmaq",
  "rateOperator": "⭐ Operatoru qiymətləndirmək",
  "editContact": "✎ Şəxsi məlumatlarımı dəyiş",
  "searchingOperator": "🔎 Sizin üçün operator axtarılır...",
  "waitingOperator": "⏳ Müraciətiniz qəbul edildi. Operatorun qoşulmasını gözləyin.",
  "operatorJoined": "Operator {{name}} söhbətə qoşuldu",
  "sendFailedShort": "Göndərilmədi",
  "retry": "Yenidən cəhd",
  "cameraShot": "📷 Kamera ilə şəkil çək",
  "pickPhoto": "🖼️ Şəkil seç",
  "pickVideo": "🎬 Video seç",
  "pickFile": "📁 Fayl və sənəd seç",
  "textPlaceholder": "Mətn...",
  "messageAria": "Mesaj",
  "sendAria": "Göndər",
  "emojiAria": "Emoji",
  "rateTitle": "Operatoru qiymətləndirmək",
  "submitRate": "Göndərmək",
  "editContactTitle": "Şəxsi məlumatlarımı dəyiş",
  "cameraPermissionTitle": "Kamera icazəsi",
  "cameraPermissionBody": "Şəkil çəkmək üçün kameraya giriş icazəsi lazımdır. Brauzerin öz pəncərəsi cihaz dilində qala bilər.",
  "allowCamera": "İcazə ver",
  "notNow": "İndi yox",
  "namePlaceholder": "Ad",
  "topic_deposit": "Depozit problemi",
  "topic_withdraw": "Çıxarış problemi",
  "topic_balance": "Balans problemi",
  "topic_game": "Oyun problemi",
  "topic_bonus": "Bonus problemi",
  "topic_account": "Hesab və giriş problemi",
  "topic_tech": "Texniki problem",
  "topic_other": "Digər sual",
  "fileOpenFailed": "Faylı açmaq mümkün olmadı: {{name}}",
  "retryShort": "Yenidən",
  "fileLoading": "Fayl yüklənir: {{name}}",
  "emoji_smileys": "Üzlər",
  "emoji_people": "Jestlər",
  "emoji_nature": "Təbiət",
  "emoji_food": "Yemək",
  "emoji_activity": "İdman",
  "emoji_travel": "Səyahət",
  "emoji_objects": "Əşyalar",
  "emoji_symbols": "Simvollar",
  "emoji_flags": "Bayraqlar"
}
